/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { get, defaultsDeep } from 'lodash';
import {
  Text,
  Placeholder,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import { Container, Row, Column } from '../../../styles/Grid';
import Spacer from '../../ui/Spacer';
import { fieldHasValue } from '../../../utils/sitecore';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  containerCss,
  containerMarginCss,
  containerPaddingCss,
  titleCss,
} from './index.styles';

const defaultData = {
  Title: {
    value: '',
  },
};

class Downloads extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const fields = defaultsDeep(props.fields, defaultData);
    const { rendering } = props;
    const isEditing = get(props, 'sitecoreContext.pageEditing', false);

    return (
      <Spacer marginCss={containerMarginCss} paddingCss={containerPaddingCss}>
        <Container>
          <Row>
            {(isEditing || fieldHasValue(fields.Title)) && (
              <Column cols={{ sm: 6, md: 8, lg: 12 }}>
                <h1 css={titleCss}>
                  <Text field={fields.Title} />
                </h1>
              </Column>
            )}
          </Row>
          <div css={containerCss}>
            <Placeholder name="jss-downloads-container" rendering={rendering} />
          </div>
        </Container>
      </Spacer>
    );
  }
}

Downloads.displayName = 'Downloads';

Downloads.defaultProps = { fields: defaultData };

Downloads.propTypes = {
  Title: PropTypes.shape({
    value: PropTypes.string,
  }),
};

export default withSitecoreContext()(Downloads);
